<div
  class="progress-container"
  [class.full-width]="isFullWidth"
  [class.no-top-border-radius]="noProgressContainerTopBorderRadius"
  [class.no-bottom-border-radius]="noProgressContainerBottomBorderRadius"
  [style.background]="background"
>
  <div
    class="progress-bar"
    [class.has-border-radius]="progressBarBorderRadius"
    [class.no-box-shadow]="noProgressBarBoxShadow"
    [style.width.%]="percents"
    [style.height.rem]="height"
  ></div>
</div>
